import { BrowserRouter, Routes, Route } from "react-router-dom"
import { DataProvider } from "@/lib/data-context"
import { AuthProvider } from "@/lib/auth-context"
import { AuthGuard } from "@/components/auth/AuthGuard"
import Home from "./pages/Home"

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <AuthGuard>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </AuthGuard>
        </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  )
}

export default App
